class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
  
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });
  
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
  
        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
  
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerDonation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Safe to access DOM here
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.form = document.querySelector('.cart-drawer-donation__form');
      this.donationFormItem = this.form.querySelector('input[name="id"]');
      this.donationFormQuantity = this.form.querySelector('input[name="quantity"]');

      this.fixedDonationButtons = document.querySelectorAll('.cart-drawer-fixed-donation-btn');
      this.fixedDonationButtons.forEach(btn => {
        btn.addEventListener('click', this.handleFixedDonationBtnClick.bind(this));
      });
      
      this.variableDonationButton = document.querySelector('.cart-drawer-donation-variable__label');
      this.variableDonationButton.addEventListener('click', this.handleVariableDonationBtnClick.bind(this));
    }

    handleFixedDonationBtnClick(event){
      // Get the 'for' attribute to find the corresponding radio input
      const radioId = event.currentTarget.getAttribute('for');
      const radio = document.getElementById(radioId);
      
      if (radio && radio.type === 'radio') {
        //Set Form Data
        this.donationFormItem.value = radio.value;
        this.donationFormQuantity.value = 1;

        //Submit form
        this.onSubmitDonation(event);
      }
    }

    handleVariableDonationBtnClick(event){
      const radio = document.getElementById('cart-drawer-donation-variable');
      const qty = document.querySelector('.cart-drawer-donation-variable__input');
      
      if (radio && radio.type === 'radio') {
        //Set Form Data
        this.donationFormItem.value = radio.value;
        this.donationFormQuantity.value = parseInt(qty.value.replace(/[^0-9.,]/,''), 10) || 0;

        //Submit form
        this.onSubmitDonation(event);
      }
    }

    onSubmitDonation(evt) {
        //this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
        formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: 'cart-drawer-donation-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
            });
            //this.handleErrorMessage(response.description);
            
            return;
            } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-drawer-donation-form',
                productVariantId: formData.get('id'),
                cartData: response,
            }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
            this.error = false;
            
            CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
            });
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            
            CartPerformance.measureFromEvent("add:user-action", evt);
        });
    }
}

customElements.define('cart-drawer-donation', CartDrawerDonation);
  